import { render, staticRenderFns } from "./FromRefID.vue?vue&type=template&id=28b5c342&"
import script from "./FromRefID.vue?vue&type=script&lang=js&"
export * from "./FromRefID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports